import { Box, Typography } from '@mui/material'

export default function Footer() {
  return (
    <Box
      sx={{
        py: 2,
        mt: 2,
        textAlign: 'center',
        borderTop: '1px solid #dddddd'
      }}
    >
      <Typography fontSize={12}>
        Copyright © All rights reserved.
      </Typography>
    </Box>
  )
}
